import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// Dev-only PIN codes
const VALID_PINS: Record<string, { userId: string; name: string }> = {
  '602820': { userId: 'user-1', name: 'User 1' },
  '303588': { userId: 'user-2', name: 'User 2' },
}

interface AuthState {
  isAuthenticated: boolean
  userId: string | null
  userName: string | null
  login: (pin: string) => boolean
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      userId: null,
      userName: null,
      
      login: (pin: string) => {
        const user = VALID_PINS[pin]
        if (user) {
          set({
            isAuthenticated: true,
            userId: user.userId,
            userName: user.name,
          })
          return true
        }
        return false
      },
      
      logout: () => {
        set({
          isAuthenticated: false,
          userId: null,
          userName: null,
        })
      },
    }),
    {
      name: 'librarian-auth',
    }
  )
)
